import { pluralize } from '../../../../../utils/pluralize';
import { Flex } from '../../../../layout/Flex';
import { Wrapper } from '../../styles';
import { ProfileAvatar } from '../ProfileAvatar/ProfileAvatar';
import { ProfileInfo } from '../ProfileInfo/ProfileInfo';
import { ProfileStatItem } from '../ProfileStatItem/ProfileStatItem';

import { UserProfileProps } from './types';

export const UserProfile = ({
    user,
    children,
    cpaButton,
    onShowSubscriptions,
    ...other
}: UserProfileProps) => {
    const { subscriptions } = user;

    return (
        <Wrapper {...other}>
            <Flex direction="row" spacing={2} width="100%" justifyContent="space-between">
                <Flex spacing={2}>
                    <Flex direction="row" spacing={2}>
                        <ProfileAvatar avatarUrl={user.avatarUrl} title={user.displayName} />
                        <ProfileInfo
                            title={user.displayName}
                            user={user}
                            subtitle={user.login}
                            cpaButton={cpaButton}
                        />
                    </Flex>
                    {subscriptions > 0 ? (
                        <ProfileStatItem
                            value={subscriptions}
                            label={pluralize(subscriptions, 'подписка', 'подписки', 'подписок')}
                            onClick={onShowSubscriptions}
                        />
                    ) : null}
                </Flex>
            </Flex>
            {children}
        </Wrapper>
    );
};
